import React, { useState } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Image } from "hesus-ui-kit";
import commentIcon from "@icons/ic-comment.svg";
import closeIcon from "@icons/ic-close.svg";

import {
  CommentButton,
  CommentsTitle,
  CloseButton,
  GroupComments,
  CommentsTextTitle,
  CommentText,
} from "./Solutions.styled";
import { PopUpContainer, PopUpBox } from "@shared/styles/common.styled";

const Comment = (props) => {
  const { comment, t } = props;
  const [isCommentVisible, setCommentVisibility] = useState(false);

  const toggleComment = () => {
    setCommentVisibility(true);
  };

  const closeCommentPopup = () => {
    setCommentVisibility(false);
  };

  return (
    <div>
      <CommentButton onClick={toggleComment}>
        <Image src={commentIcon} alt="comment" styles={{ width: "24px" }} />
      </CommentButton>
      {isCommentVisible && (
        <PopUpContainer>
          <PopUpBox>
            <div>
              <CommentsTitle>
                {t("KICKOFF_QUOTE_VIEW_COMMENTS_POP_UP")}
              </CommentsTitle>
              <CloseButton onClick={closeCommentPopup}>
                <Image src={closeIcon} alt="Close comment popup." />
              </CloseButton>
            </div>
            <GroupComments>
              <CommentsTextTitle>
                {t("KICKOFF_QUOTE_VIEW_COMMENTS_POP_UP_DEFAULT_COMMENT")} :
              </CommentsTextTitle>
              <CommentText>{comment?.comment ?? ""}</CommentText>
              <CommentsTextTitle>
                {t(
                  "KICKOFF_QUOTE_VIEW_COMMENTS_POP_UP_PURCHASE_PRICE_ASUMPTION"
                )}{" "}
                :
              </CommentsTextTitle>
              <CommentText>{comment?.internalComment}</CommentText>
              <CommentsTextTitle>
                {t("KICKOFF_QUOTE_VIEW_COMMENTS_POP_UP_CONCERNED_POLLUTION")} :
              </CommentsTextTitle>
              <CommentText>{comment?.pollutionComment ?? ""}</CommentText>
              <CommentsTextTitle>
                {t("KICKOFF_QUOTE_VIEW_COMMENTS_POP_UP_QUOTE_COMMENT")} :
              </CommentsTextTitle>
              <CommentText>{comment?.quoteComment ?? ""}</CommentText>
            </GroupComments>
          </PopUpBox>
        </PopUpContainer>
      )}
    </div>
  );
};

Comment.propTypes = {
  comment: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Comment);
